module.exports = __webpack_public_path__ + "static/media/faq-website.27055547.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/faq-website.svg
// module id = 1378
// module chunks = 49